import { BaseEntity } from 'yt-ng-framework';

export class Izvestaj extends BaseEntity {
    constructor(){
        super();
    }
    Opis: string = null;
    Path: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Opis = input.Opis;
        this.Path = input.Path;
        return this;
    }

    Serialize(input: Izvestaj){
        return input;
    }
}
